import { TagTypeType } from 'src/graphql';
import { TagTypeStatus } from '../../../types';
import { Summary } from '../Summary';

interface Props {
  orderedTagTypes?: TagTypeType[] | null;
  orderedTags?: Array<unknown> | null;
}

export const TagsSummary = ({ orderedTagTypes, orderedTags }: Props) => {
  const totalTags = orderedTags?.length;
  const totalActiveTags = orderedTagTypes?.filter(
    (tagType) => tagType.status === TagTypeStatus.LIVE,
  ).length;
  const pausedTags = orderedTagTypes?.filter(
    (tagType) => tagType.status === TagTypeStatus.PAUSED,
  ).length;

  const itemTotals = [
    { title: 'Total tags created', value: totalTags ?? 0 },
    { title: 'Total tag types set live', value: totalActiveTags ?? 0 },
    { title: 'Total tag types paused', value: pausedTags ?? 0 },
  ];

  return <Summary itemTotals={itemTotals} />;
};
